<template>
	<div>
		<div class="w">
			<SecondHead textColor="#333" color="#333" ref="myHeader"></SecondHead>
		</div>
		<el-container>
			<!-- <el-header>
				<span @click="GoGo()">
					<i class="el-icon-arrow-left" style="color: #666; line-height:60px ;"></i>
				</span>
			</el-header> -->
			
			
			<el-main>
				<el-tabs v-model="activeName">
					<el-tab-pane :label="$t('main.myDownloads')" name="first">
						<el-table :data="tableData" stripe style="width: 100%">
							<el-table-column  prop="fileName" :label="$t('MyDownloads.FileName')" ></el-table-column>
							<el-table-column width="100px" prop="fileType" :label="$t('MyDownloads.FileType')" ></el-table-column>
							<el-table-column prop="createtime" :label="$t('MyDownloads.Time')" ></el-table-column>
							<el-table-column prop="fileSize" :label="$t('MyDownloads.FileSize')"></el-table-column>
							<el-table-column prop="status" :label="$t('MyDownloads.State')" ></el-table-column>
							<el-table-column
							
								fixed="right"
								:label="$t('main.operate')"
								width="100">
								<template #default="scope">
									<el-link :underline="false" type="primary" :disabled="scope.row.status != $t('MyDownloads.CanDownloaded')" @click="handleClick(scope.row)">{{$t('MyDownloads.Download')}}</el-link>
								</template>
								</el-table-column>
						</el-table>
						<div class="block">
							<el-pagination
								background
								style="position: absolute;bottom: 0px; right: 10px;"
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="pageIndex"
								:page-size="pageSize"
								layout="total, prev, pager, next, jumper"
								:total="total"
							></el-pagination>
						</div>
					</el-tab-pane>
				</el-tabs>
			</el-main>
		</el-container>
	</div>
</template>

<script>
import SecondHead from '@/components/SecondHead';
export default {
	components: {
		SecondHead
	},
	data() {
		return {
			total:1,
			pageIndex:1,
			pageSize:10,
			go:-1,
			activeName: 'first',
			tableData: [
			]
		};
	},
	mounted: function() {
		this.queryDownloadRecord()
	},
	methods: {
		GoGo(){
			this.$router.go(this.go);
		},
		handleClick(tab, event) {  // 下载
		
			window.open(this.$config.service.downloadFile + '?id=' + tab.id + '&Authorization=' + 'Bearer ' + window.localStorage.getItem('token'));
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.pageIndex= val
			this.queryDownloadRecord()
		},
		queryDownloadRecord(){
			// ?pageSize=${pageSize}pageIndex
			this.tableData=[]
			let that =this
			let params = {
				that: this,
				url: `${this.$config.service.queryDownloadRecord}?pageIndex=${this.pageIndex}&pageSize=${this.pageSize}`,
				method: 'GET',
				cb(res) {
					if (res.code == 0) {
						that.total = res.resultBody.total
						
						for (let i = 0;i< res.resultBody.datas.length; i++){
							let a= [that.$t('MyDownloads.DataPreparationProgress'),that.$t('MyDownloads.CanDownloaded'),that.$t('MyDownloads.ExportException'),that.$t('MyDownloads.DataExpiration')] 
							let b =['Excel','Word','zip','Sav']
							// console.log(res.resultBody.datas[i])
							a[res.resultBody.datas[i].status]
							b[res.resultBody.datas[i].fileType]
							res.resultBody.datas[i].status = a[res.resultBody.datas[i].status]
							res.resultBody.datas[i].fileType = b[res.resultBody.datas[i].fileType]
							res.resultBody.datas[i].fileName = that.htmlToString(res.resultBody.datas[i].fileName)
							that.tableData.push(res.resultBody.datas[i])
						}
					}
				}
			};
			this.$util.request(params);
		},
		htmlToString(htmlStr){
			return htmlStr.replace(/<\/?.+?\/?>|\r|\n*/g,'')
		},
	}
};
</script>

<style scoped="scoped" lang="scss">
	.block{
		width: 100%;
		height: 40px;
	}
	/deep/.el-container{
    	padding-bottom: 30px;
	}
</style>
